module.exports = __webpack_public_path__ + "img/es-es.c3914ed4.png";